module.exports = __webpack_public_path__ + "static/media/YE.efd1cd0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/YE.svg
// module id = 2293
// module chunks = 7